const storeNachas = {
    namespaced: true,
    state: {
        nachas: [],
        bankAccounts: [],
        hsaPushBankTransfers: [],
        checkFundedBankTransfers: [],
        ready: false,
    },
    getters:
    {
        nachasReady: (state) => {
            return state.ready;
        },
        nachas: (state) => {
            return state.nachas;
        },
    },
    actions: {
        async loadNachaByAccountType({ commit }, data)
        {
            if (!data) return;

            commit("setNachasReady", false);
            let result = await romeApi.get(`participant/nacha/recent`, { abaId: data.abaId, direction: data.direction } );

            commit("setNachas", result);
        },
        async loadBankAccountTypes({ commit }){
            commit("setNachasReady", false);
            let result = await romeApi.get(`participant/nacha/bankAccounts`);
            commit("setBankAccounts", result)
        },
        async loadHsaPushBankTransfers({ commit })
        {
            console.log("loadHsaPushBankTransfers");
            commit("setNachasReady", false);
            let result =  await romeApi.get(`banktransfer/hsa/AllEntry`);
            commit("setHsaBankTransfers", result);
        },
        async loadCheckFundedBankTransfers({ commit }){
            commit("setNachasReady", false);
            let result = await romeApi.get(`banktransfer/check-funded`);
            commit("setCheckFundedBankTransfers", result);
        }
    },
    mutations: {
        setNachas(state, nachas) {
            state.nachas = nachas.sort((a,b)=> (b.createdAt > a.createdAt) ? 1 : -1);
            state.ready = true;
        },
        setNachasReady(state, value) {
            state.ready = value;
        },
        setHsaBankTransfers(state, bankTransfers)
        {
            state.hsaPushBankTransfers = bankTransfers;
            state.ready = true;
        },
        setBankAccounts(state, bankAccounts){
            state.bankAccounts = bankAccounts;
            state.ready = true;
        },
        setCheckFundedBankTransfers(state, bankTransfers)
        {
            state.checkFundedBankTransfers = bankTransfers;
            state.ready = true;
        }
    }
};

export default storeNachas;



// WEBPACK FOOTER //
// ./src/finance/x-nachas.js